import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillMail = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.73 12.8C12.32 13.2 11.67 13.2 11.26 12.8L3.19001 4.72C3.08001 4.61 3.04001 4.45 3.09001 4.3C3.19001 4 3.44001 4 3.67001 4H20.33C20.56 4 20.82 4 20.91 4.3C20.96 4.45 20.92 4.62 20.81 4.73L12.73 12.8ZM21.74 5.52C21.79 5.49 21.86 5.49 21.91 5.52V5.53C21.97 5.55 22 5.61 22 5.67V18.33C22 19.25 21.25 20 20.33 20H3.67C2.75 20 2 19.25 2 18.33V5.67C2.01 5.62 2.04 5.58 2.09 5.56C2.14 5.53 2.21 5.53 2.26 5.56L10.38 13.65C10.81 14.08 11.39 14.32 12 14.32C12.61 14.32 13.19 14.08 13.62 13.65L21.74 5.52Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillMail)
